import React from 'react';
import Hero from '../components/Hero';
import FeaturedSpices from '../components/FeaturedSpices';
import Categories from '../components/Categories';
import Recipes from '../components/Recipes';

const HomePage = () => {
  return (
    <>
      <Hero />
      <FeaturedSpices />
      <Categories />
      <Recipes />
    </>
  );
};

export default HomePage;
